export const SIDENAV_WIDTH = 64;
export const TOPBAR_HEIGHT = 48;
export const PICKLIST_DELIMITER_LEFT = '[';
export const PICKLIST_DELIMITER_RIGHT = ']';
